import Splide from '@splidejs/splide';

const SELECTORS = {
    block: '.wp-block-ssm-timeline',
    yearsSlider: '.wp-block-ssm-timeline__years',
    contentSlider: '.wp-block-ssm-timeline__content',
};

const YEARS_OPTIONS = {
    type: 'slide',
    gap: '3.75rem',
    perPage: 5,
    pagination: false,
    arrows: false,
    drag: true,
    focus: 'center',
    updateOnMove: true,
    isNavigation: true,
    breakpoints: {
        768: {
            perPage: 4,
            gap: '2rem',
        },
    },
};

const CONTENT_OPTIONS = {
    type: 'fade',
    perPage: 1,
    pagination: false,
    arrows: true,
    drag: true,
    speed: 600,
};

export function initTimeline(block) {
    const yearsEl = block.querySelector(SELECTORS.yearsSlider);
    const contentEl = block.querySelector(SELECTORS.contentSlider);

    if (!yearsEl || !contentEl || yearsEl.splide || contentEl.splide) {
        return null;
    }

    try {
        const yearsSlider = new Splide(yearsEl, YEARS_OPTIONS);
        const contentSlider = new Splide(contentEl, CONTENT_OPTIONS);

        yearsSlider.sync(contentSlider);
        yearsSlider.mount();
        contentSlider.mount();

        return {
            destroy() {
                if (yearsSlider && typeof yearsSlider.destroy === 'function') {
                    yearsSlider.destroy();
                }
                if (contentSlider && typeof contentSlider.destroy === 'function') {
                    contentSlider.destroy();
                }
                delete yearsEl.splide;
                delete contentEl.splide;
            },
        };
    } catch (error) {
        console.error('Error initializing Timeline carousel:', error);

        return null;
    }
}

export function Timeline() {
    document.querySelectorAll(SELECTORS.block).forEach((block) => {
        initTimeline(block);
    });
}
